import Route from '@ember/routing/route';
import { Registry, service } from '@ember/service';

export interface JoinMeetingModel {
  appointmentId: string;
  token: string;
  email: string;
  name: string | null;
  passwordless: boolean;
  invalid: boolean;
}

export default class JoinMeeting extends Route {
  @service api!: Registry['api'];

  async model({ appointment, token }: { appointment: string; token: string }): Promise<JoinMeetingModel> {
    const model: JoinMeetingModel = {
      appointmentId: appointment,
      token,
      email: '',
      name: null,
      passwordless: false,
      invalid: false,
    };

    try {
      const details = await this.api.getMeetingLink({ appointmentId: appointment, token });
      model.email = details.email ?? '';
      model.name = details.name ?? null;
      model.passwordless = details.passwordless ?? false;
    } catch {
      // an expired or tampered link still renders the page, the form just reports the problem
      model.invalid = true;
    }

    return model;
  }
}
